import { expiredSessionInterceptor, gatewayTimeoutInterceptor, misleadingHtmlResponseInterceptor } from '@/api/helpers'
import config from '@/config'
import axios, { type AxiosInstance } from 'axios'

const testMode = import.meta.env.MODE === 'test'

const axiosInstance: AxiosInstance = axios.create({
    baseURL: config.devApiUrl || config.dashboardApiAddress,
    headers: {},
})

!testMode && axiosInstance.interceptors.response.use(
    misleadingHtmlResponseInterceptor,
    async (error) => {
        return await expiredSessionInterceptor(error, axiosInstance)
    },
)

!testMode && axiosInstance.interceptors.response.use(
    (res) => res,
    async (error) => {
        return await gatewayTimeoutInterceptor(error)
    },
)

export default axiosInstance
